import { gql } from '@apollo/client';
import { EnvironmentType } from '../../../types';
import { GetEnvironmentsProps } from './environment.types';

export const GET_ENVIRONMENTS = gql`
  query Environments($uid: ID!){
    environments(uid: $uid) {
      appEnvId
    }
  }
`;

export const CAN_ACCESS_ENVIRONMENT = gql`
  query CanAccessEnvironment{
    canAccessEnvironment
  }
`;

export function getEnvironments({ client, uid }: GetEnvironmentsProps) {
  return client?.watchQuery<{ environments: EnvironmentType[] }>({
    query: GET_ENVIRONMENTS,
    variables: { uid },
  });
}

export function fetchEnvironments({ client, uid }: GetEnvironmentsProps) {
  return client?.query<{ environments: EnvironmentType[] }>({
    query: GET_ENVIRONMENTS,
    variables: { uid },
  });
}
